var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 687,
    height: 192,
    viewBox: "0 0 687 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M651.028 211.989H29.7559C47.2669 180.371 69.488 151.601 95.6559 126.669C100.165 122.379 104.784 118.208 109.513 114.156C171.566 60.912 252.221 28.7539 340.386 28.7539C416.983 28.7539 487.91 53.0253 545.894 94.3C567.639 109.776 587.577 127.645 605.334 147.569C607.37 149.85 609.373 152.158 611.344 154.494C625.377 171.074 637.862 188.905 648.64 207.763C649.44 209.167 650.236 210.576 651.028 211.989Z",
    fill: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M552.905 149.121C552.905 149.121 538.49 152.725 534.371 152.725H534.121C531.19 152.657 524.697 151.445 515.684 148.349C511.312 146.847 506.35 144.902 500.912 142.432C496.787 140.578 492.452 139.234 488.002 138.428C479.561 136.855 471.95 137.169 466.838 136.969C464.664 136.883 462.941 136.708 461.8 136.254C456.652 134.195 444.282 124.928 444.282 124.928C444.282 124.928 449.945 125.958 454.064 122.869C458.182 119.78 462.816 108.969 462.816 108.969L487.58 113.287L507.09 116.691L523.435 116.956L539.008 117.206L552.905 149.121Z",
    fill: "#747474"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.85
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M534.121 152.72C531.19 152.652 524.697 151.441 515.685 148.344L510.679 121.32L494.72 120.291L488.003 138.427C479.562 136.854 471.95 137.169 466.838 136.968L479.304 114.113L487.595 113.283L494.745 112.568L523.06 115.657L523.446 116.951L534.121 152.72Z",
    fill: "#747474"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M651.028 211.989H29.7559C47.2669 180.371 69.488 151.601 95.6559 126.669C100.165 122.379 104.784 118.208 109.513 114.156C113.649 116.859 118.304 119.876 122.616 122.543C129.469 126.834 135.468 130.316 137.191 130.602C141.839 131.374 147.23 138.324 147.23 138.324C147.588 138.581 163.458 149.822 185.127 156.954C199.248 161.602 215.833 164.515 232.179 161.487C263.818 155.628 291.604 134.359 303.17 124.435C306.705 121.403 308.725 119.43 308.89 119.287C308.89 119.287 313.101 119.387 320.044 119.565L326.093 119.723C337.466 120.027 353.264 120.47 369.588 120.995C372.959 121.103 376.352 121.214 379.738 121.331C383.996 121.475 388.236 121.625 392.39 121.778L393.791 121.832L400.152 122.075C413.404 122.594 425.292 123.148 433.4 123.713C439.431 124.127 443.385 124.546 444.276 124.95C445.005 125.293 445.657 125.779 446.195 126.38C449.806 130.191 451.941 138.771 485.829 148.374C499.089 152.131 510.251 153.801 519.435 154.269C541.937 155.42 552.523 149.36 552.877 149.149C559.315 151.029 565.872 152.473 572.504 153.472C578.049 154.262 583.758 154.605 588.142 153.783C588.885 153.643 589.679 153.457 590.515 153.232C594.755 152.102 600.068 149.972 605.306 147.609C607.341 149.889 609.344 152.198 611.315 154.534C625.349 171.113 637.833 188.944 648.611 207.803C649.431 209.18 650.236 210.576 651.028 211.989Z",
    fill: "#F1F1F1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M407.205 99.1841C407.205 99.1841 400.77 98.5907 395.643 98.2618C392.494 98.0616 389.834 97.9579 389.444 98.1545C388.69 98.512 386.148 100.7 384.836 101.833C384.353 102.252 384.038 102.548 384.038 102.548L367.725 105.862L367.564 105.895L360.872 103.835L351.862 102.806H344.662L352.127 78.6094L364.661 79.1993L380.206 79.9322L386.455 80.2253L395.886 80.6686C395.886 80.6686 402.321 93.0242 403.351 95.0835C404.381 97.1428 407.205 99.1841 407.205 99.1841Z",
    fill: "#747474"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.85
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M380.206 79.9142L384.853 101.833C384.371 102.252 384.056 102.548 384.056 102.548L367.743 105.862C367.275 99.9027 365.265 80.4112 365.265 80.4112L364.672 79.1992L380.206 79.9142Z",
    fill: "#747474"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.85
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M407.205 99.1837C407.205 99.1837 400.77 98.5902 395.643 98.2613C392.805 92.5412 388.704 84.5687 386.448 80.207L395.879 80.6503C395.879 80.6503 402.315 93.0059 403.344 95.0652C404.374 97.1245 407.205 99.1837 407.205 99.1837Z",
    fill: "#747474"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M352.127 78.5917C352.127 78.5917 355.216 87.3435 364.483 86.8144C373.749 86.2853 385.075 82.6959 385.075 82.6959L395.886 80.6366C395.886 80.6366 395.886 72.4139 391.768 72.4139C387.649 72.4139 380.442 68.2953 376.323 68.8102C372.205 69.325 367.571 70.3546 365.512 71.8991C363.453 73.4435 353.157 75.5028 353.157 75.5028L352.127 78.5917Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M449.924 211.99H348.033L356.081 187.418L379.072 188.898L380.227 188.973L410.172 190.904L422.213 191.679L440.382 192.849C440.382 192.849 445.791 203.66 449.924 211.99Z",
    fill: "#747474"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.85
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M414.27 211.989H383.08C382.837 209.025 382.598 206.165 382.365 203.563C381.772 196.484 381.332 191.329 381.332 191.329L380.228 188.973L410.173 190.903L411.653 198.55L414.27 211.989Z",
    fill: "#747474"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.85
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M449.924 211.99H432.231C429.371 206.134 426.511 200.324 424.205 195.644C423.49 194.214 422.832 192.874 422.242 191.68L440.411 192.849C440.411 192.849 445.791 203.66 449.924 211.99Z",
    fill: "#747474"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M356.081 187.418C356.081 187.418 361.744 204.397 379.63 203.71C397.517 203.024 419.468 196.456 419.468 196.456L440.382 192.849C440.382 192.849 440.657 176.968 432.717 176.829C424.777 176.69 411.016 168.51 403.044 169.368C395.071 170.226 386.119 172.053 382.097 174.963C378.075 177.873 358.144 181.498 358.144 181.498L356.081 187.418Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M462.812 108.965C463.842 110.509 482.89 126.983 497.305 128.013C511.72 129.042 530.768 124.924 532.313 124.924C533.857 124.924 543.639 118.746 539.005 117.202C534.372 115.657 522.531 109.479 518.927 109.479C515.324 109.479 489.068 103.816 481.861 103.816C474.653 103.816 463.842 105.876 463.842 105.876L462.812 108.965Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M115.226 211.989H46.9092L51.3387 198.025L51.9894 195.969L55.0354 195.018L69.8399 190.392L76.9401 188.172L84.9376 185.669L88.3411 184.121L101.927 177.947C101.927 177.947 107.59 207.292 114.282 211.41L115.226 211.989Z",
    fill: "#747474"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.85
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5419 197.182L68.8494 211.99H52.3252L54.5632 197.975L55.0351 195.019L69.8397 190.393L68.4632 193.396L68.5419 197.182Z",
    fill: "#747474"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.85
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6991 211.989H86.3313L79.8103 195.443L76.9502 188.172L84.9477 185.669L88.3512 184.121C88.6265 185.437 89.0662 187.496 89.6311 189.938C91.2757 197.092 93.9999 207.509 96.6991 211.989Z",
    fill: "#747474"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9596 198.046C50.9596 198.046 66.404 198.046 77.73 195.986C89.0559 193.927 101.926 177.968 101.926 177.968C101.926 177.968 93.1745 174.879 89.5708 175.394C85.967 175.909 70.5226 182.086 70.0078 184.146C69.4929 186.205 51.9892 189.294 50.9596 190.838C49.9299 192.383 50.9596 198.046 50.9596 198.046Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M308.889 119.261C308.889 119.261 305.286 123.908 303.226 124.409C302.461 124.598 297.02 126.279 290.399 128.42C279.173 132.053 264.558 137.001 263.586 138.309C262.274 140.057 252.438 145.881 247.916 148.234C247.108 148.655 246.486 148.949 246.082 149.12C243.508 150.15 216.223 155.298 216.223 155.298C216.223 155.298 206.72 152.999 196.324 150.532C184.14 147.633 170.715 144.487 169.868 144.487C169.51 144.487 167.984 144.129 165.906 143.582C159.368 141.866 147.216 138.309 147.216 138.309L165.749 118.746L176.471 115.818L252.481 94.9251L253.797 94.5676L267.182 94.0527C267.182 94.0527 297.042 116.19 299.101 116.705C301.16 117.219 308.889 119.261 308.889 119.261Z",
    fill: "#747474"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.85
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M290.392 128.421C279.166 132.053 264.551 137.001 263.579 138.31C262.267 140.058 252.432 145.882 247.909 148.234L245.56 147.062L224.467 108.45L195.638 113.098L196.353 150.547C184.169 147.648 170.744 144.502 169.897 144.502C169.539 144.502 168.013 144.144 165.936 143.597L176.471 115.819L252.482 94.9258C260.433 101.979 280.064 119.498 282.112 122.365C283.271 123.974 286.828 126.326 290.392 128.421Z",
    fill: "#747474"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M175.03 119.777C178.634 119.777 190.475 120.292 203.86 120.292C217.245 120.292 239.89 108.966 239.89 108.966C239.89 108.966 267.69 95.5811 267.175 94.0366C266.66 92.4922 263.057 86.3144 255.334 86.8292C247.612 87.344 225.99 94.0366 217.238 96.0959C208.486 98.1552 194.071 99.1848 189.438 102.789C184.805 106.392 171.419 113.085 171.419 113.085C171.419 113.085 162.668 116.689 165.764 118.748C168.86 120.807 175.03 119.777 175.03 119.777Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M565.154 200.255C567.442 201.238 574.721 204.974 583.215 208.632C591.71 212.289 611.301 207.527 611.301 207.527C611.301 207.527 635.101 202.164 635.487 200.548C635.873 198.932 636.424 191.968 631.286 190.341C626.149 188.715 609.346 189.29 602.843 188.89C596.34 188.489 586.715 185.544 582.107 187.764C577.499 189.984 565.933 192.797 565.933 192.797C565.933 192.797 558.722 193.87 559.734 196.73C560.746 199.59 565.154 200.255 565.154 200.255Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M332.646 73.3062C330.09 78.2291 321.295 83.245 310.191 85.6082C297.499 88.3109 286.148 86.6199 283.174 81.8865C282.864 81.4002 282.642 80.8628 282.52 80.2991C281.261 74.3787 291.608 67.1606 305.629 64.1754C319.651 61.1901 332.042 63.5676 333.301 69.488C333.542 70.798 333.31 72.1511 332.646 73.3062Z",
    fill: "#F1F1F1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M332.646 73.3075C330.09 78.2304 321.295 83.2463 310.191 85.6094C297.499 88.3122 286.148 86.6212 283.174 81.8877C285.73 76.9612 294.528 71.9453 305.629 69.5822C318.321 66.8794 329.679 68.5704 332.646 73.3075Z",
    fill: "#F1F1F1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M211.836 84.2972C210.405 87.4611 204.778 90.7324 197.632 92.2589C190.757 93.7247 184.504 93.1313 181.726 91.0255C181.004 90.5258 180.489 89.7795 180.278 88.9269C179.488 85.216 185.977 80.7042 194.772 78.8165C203.566 76.9289 211.335 78.4376 212.125 82.1485C212.263 82.8772 212.161 83.6308 211.836 84.2972Z",
    fill: "#F1F1F1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M211.836 84.2967C210.406 87.4606 204.779 90.7319 197.632 92.2584C190.757 93.7242 184.504 93.1308 181.727 91.025C183.157 87.8611 188.784 84.5898 195.93 83.0633C202.809 81.5975 209.058 82.2124 211.836 84.2967Z",
    fill: "#F1F1F1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M378.247 52.9793C376.266 54.6954 371.379 55.1637 366.002 53.9482C360.829 52.7827 356.732 50.3981 355.491 48.0779C355.155 47.5071 355.038 46.8336 355.163 46.183C355.795 43.3909 361.669 42.3398 368.287 43.8342C374.904 45.3286 379.756 48.8072 379.126 51.5993C378.99 52.1421 378.681 52.6262 378.247 52.9793Z",
    fill: "#F1F1F1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M378.247 52.9788C376.266 54.6948 371.379 55.1632 366.002 53.9476C360.829 52.7821 356.732 50.3976 355.491 48.0773C357.475 46.3648 362.363 45.8965 367.74 47.112C372.931 48.2811 377.024 50.6621 378.247 52.9788Z",
    fill: "#F1F1F1"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M416.93 129.429C426.206 129.429 433.726 126.231 433.726 122.286C433.726 118.341 426.206 115.143 416.93 115.143C407.654 115.143 400.134 118.341 400.134 122.286C400.134 126.231 407.654 129.429 416.93 129.429Z",
    fill: "#F1F1F1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M347.429 132.518C359.904 132.518 370.017 128.197 370.017 122.866C370.017 117.535 359.904 113.213 347.429 113.213C334.955 113.213 324.842 117.535 324.842 122.866C324.842 128.197 334.955 132.518 347.429 132.518Z",
    fill: "#F1F1F1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M386.813 126.341C390.758 126.341 393.956 123.748 393.956 120.549C393.956 117.351 390.758 114.758 386.813 114.758C382.868 114.758 379.67 117.351 379.67 120.549C379.67 123.748 382.868 126.341 386.813 126.341Z",
    fill: "#F1F1F1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M581.606 162.249C586.937 162.249 591.259 159.31 591.259 155.685C591.259 152.06 586.937 149.121 581.606 149.121C576.275 149.121 571.953 152.06 571.953 155.685C571.953 159.31 576.275 162.249 581.606 162.249Z",
    fill: "#F1F1F1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M561.335 172.675C563.361 172.675 565.003 171.119 565.003 169.2C565.003 167.28 563.361 165.725 561.335 165.725C559.309 165.725 557.667 167.28 557.667 169.2C557.667 171.119 559.309 172.675 561.335 172.675Z",
    fill: "#F1F1F1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M426.389 148.735C429.588 148.735 432.181 146.92 432.181 144.681C432.181 142.442 429.588 140.627 426.389 140.627C423.191 140.627 420.598 142.442 420.598 144.681C420.598 146.92 423.191 148.735 426.389 148.735Z",
    fill: "#F1F1F1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M307.467 149.892C309.813 149.892 311.714 148.769 311.714 147.383C311.714 145.997 309.813 144.873 307.467 144.873C305.121 144.873 303.22 145.997 303.22 147.383C303.22 148.769 305.121 149.892 307.467 149.892Z",
    fill: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M456.692 93.4856C456.495 94.1095 456.194 94.6957 455.802 95.2195C453.425 98.4371 447.754 99.5776 441.988 97.7614C436.128 95.9167 432.106 91.6158 432.113 87.576C432.113 86.9853 432.204 86.3981 432.381 85.8349C433.79 81.3588 440.375 79.4462 447.086 81.5448C453.796 83.6433 458.101 89.006 456.692 93.4856Z",
    fill: "#F1F1F1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M455.802 95.2195C453.425 98.4371 447.754 99.5776 441.988 97.7614C436.128 95.9167 432.106 91.6158 432.113 87.5759C434.491 84.3583 440.161 83.2179 445.928 85.034C451.787 86.8788 455.827 91.1796 455.802 95.2195Z",
    fill: "#F1F1F1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M489.536 87.532C489.406 87.9405 489.209 88.3246 488.953 88.6689C487.395 90.7639 483.68 91.529 479.898 90.3349C476.058 89.1265 473.423 86.3057 473.427 83.6566C473.428 83.2698 473.487 82.8854 473.602 82.5161C474.528 79.5845 478.843 78.3297 483.255 79.7133C487.666 81.0968 490.459 84.5968 489.536 87.532Z",
    fill: "#F1F1F1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M488.953 88.6692C487.395 90.7642 483.68 91.5293 479.898 90.3352C476.058 89.1268 473.423 86.306 473.427 83.6569C474.986 81.5619 478.704 80.7968 482.483 81.9909C486.322 83.2028 488.957 86.02 488.953 88.6692Z",
    fill: "#F1F1F1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M553.227 123.252C555.252 123.252 556.895 121.61 556.895 119.584C556.895 117.558 555.252 115.916 553.227 115.916C551.201 115.916 549.559 117.558 549.559 119.584C549.559 121.61 551.201 123.252 553.227 123.252Z",
    fill: "#F1F1F1"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M686.421 165.528V266.989H0V165.528C7.6126 155.968 15.6089 146.743 23.989 137.853C71.0187 87.8825 129.11 49.636 193.599 26.1842C208.042 20.9472 222.751 16.4792 237.666 12.799C272.2 4.27664 307.641 -0.021107 343.211 7.7938e-05C430.565 7.7938e-05 511.956 25.5407 580.312 69.561C608.599 87.7771 634.704 109.176 658.117 133.337C668.063 143.596 677.498 154.326 686.421 165.528Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M686.421 213.696V246.005H0V204.423C30.0387 156.575 69.7886 115.567 116.677 84.0522C180.607 41.0722 257.569 16 340.386 16C423.561 16 500.83 41.2868 564.921 84.5956C614.401 118.043 655.846 162.049 686.271 213.443L686.421 213.696Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.180cc8b0bfdcca2022eee8c766409dfd.svg";
export { ForwardRef as ReactComponent };